module.exports = __webpack_public_path__ + "assets/home_logo_svg-1.971d02ee36ed68ea8db28395d8f292d1.svg";